
import {whatsapp_share} from "./script.js"
import { wa_share_btn } from "./script"

wa_share_btn.addEventListener('click', ()=>{
    whatsapp_share()
})